
<div *ngIf="data.items" class="plan-list" style="margin:0px;">
  <!--<div class="plan-list-title">{{data.title | locale}} : {{data.items.length}} {{'items' | locale}}</div>-->
  <div *ngFor="let item of data.items" style="display:flex" class="plan-list" (click)="onClickItem(item.record)">
    <img class="map-image" style="margin:8px;" [src]="item.icon | safe: 'img'" [style.filter]="item.icon_color_filter | safe: 'style'">
    <span [innerHTML]="item.tooltip"></span>
  </div>
</div>